import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Import Vuetify styles

const vuetify = createVuetify({
  // Optional: Customize theme or other settings
  theme: {
    defaultTheme: 'light'
  }
});

export default vuetify;